import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const uploadDocumentApi = createApi({
  reducerPath: 'uploadDocumentApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['uploadDocument'],
  endpoints: (builder) => ({
    findByParkingLocationIdDoc: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.ServiceProviderDocumentController.findByParkingLocationId}${body.serviceProviderId}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
updateServiceProviderDoc: builder.mutation({
      query(body) {
        return {
            url: `${spotFinder.ServiceProviderDocumentController.updateServiceProviderDoc}${body.id}/${body.docType}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),

    uploadServiceProviderDoc: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.ServiceProviderDocumentController.uploadServiceProviderDoc}${body.serviceProviderId}/${body.docType}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.file,
        };
      },
    }),
    deleteServiceProviderDoc: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.ServiceProviderDocumentController.deleteServiceProviderDoc}${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.file,
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFindByParkingLocationIdDocMutation, useUpdateServiceProviderDocMutation, useUploadServiceProviderDocMutation, useDeleteServiceProviderDocMutation } = uploadDocumentApi;
